import { render, staticRenderFns } from "./BreedCurtainSelect.vue?vue&type=template&id=1471a428"
import script from "./BreedCurtainSelect.vue?vue&type=script&lang=js"
export * from "./BreedCurtainSelect.vue?vue&type=script&lang=js"
import style0 from "./BreedCurtainSelect.vue?vue&type=style&index=0&id=1471a428&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports